import DescriptionIcon from '@mui/icons-material/Description';
import GavelIcon from '@mui/icons-material/Gavel';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WorkIcon from '@mui/icons-material/Work';
import GroupsIcon from '@mui/icons-material/Groups';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CampaignIcon from '@mui/icons-material/Campaign';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EventIcon from '@mui/icons-material/Event';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import SchoolIcon from '@mui/icons-material/School';
import PhoneIcon from '@mui/icons-material/Phone';
import PlaceIcon from '@mui/icons-material/Place';
import LinkIcon from '@mui/icons-material/Link';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DownloadIcon from '@mui/icons-material/Download';
import FolderIcon from '@mui/icons-material/Folder';
import ArticleIcon from '@mui/icons-material/Article';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TableChartIcon from '@mui/icons-material/TableChart';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import LanguageIcon from '@mui/icons-material/Language';
import PublicIcon from '@mui/icons-material/Public';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { SvgIconComponent } from '@mui/icons-material';

// Ícones da Lista de Links pelo nome Material gravado no APM (NomIcone); nome desconhecido usa o ícone de link
const LINK_ICONS: Record<string, SvgIconComponent> = {
    // Mesmos do Acesso Rápido da home (ACESSO_RAPIDO_ICONS)
    description: DescriptionIcon,
    gavel: GavelIcon,
    account_balance: AccountBalanceIcon,
    payments: PaymentsIcon,
    receipt_long: ReceiptLongIcon,
    shopping_cart: ShoppingCartIcon,
    work: WorkIcon,
    groups: GroupsIcon,
    support_agent: SupportAgentIcon,
    campaign: CampaignIcon,
    visibility: VisibilityIcon,
    event: EventIcon,
    newspaper: NewspaperIcon,
    menu_book: MenuBookIcon,
    health_and_safety: HealthAndSafetyIcon,
    school: SchoolIcon,
    phone: PhoneIcon,
    place: PlaceIcon,
    link: LinkIcon,
    // Documentos e links
    picture_as_pdf: PictureAsPdfIcon,
    insert_drive_file: InsertDriveFileIcon,
    attach_file: AttachFileIcon,
    download: DownloadIcon,
    folder: FolderIcon,
    article: ArticleIcon,
    assignment: AssignmentIcon,
    table_chart: TableChartIcon,
    image: ImageIcon,
    video_library: VideoLibraryIcon,
    language: LanguageIcon,
    public: PublicIcon,
    open_in_new: OpenInNewIcon,
    info: InfoIcon,
    help: HelpIcon,
    email: EmailIcon,
    home: HomeIcon,
    calendar_month: CalendarMonthIcon,
};

export function LinkIconByName({ name }: { name?: string }) {
    const Icon = (name && LINK_ICONS[name.trim().toLowerCase()]) || LinkIcon;
    return <Icon fontSize="small" />;
}
